module.exports = __webpack_public_path__ + "static/media/photo6.3decefb1.png";